"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTrackingCode = exports.SendTrackingCode = exports.SendTrackingCodeActionTypes = exports.loadAdvancedTrackingCode = exports.FetchAdvancedTrackingCode = exports.FetchAdvancedTrackingCodeActionTypes = exports.loadBasicTrackingCode = exports.FetchBasicTrackingCode = exports.FetchBasicTrackingCodeActionTypes = exports.TrackingCodeActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _fluxActions = require("flux-actions");

var TrackingCodeActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_BASIC_TRACKING_CODE: null,
  FETCH_ADVANCED_TRACKING_CODE: null,
  SEND_TRACKING_CODE: null
}, 'analytics-and-tracking');
exports.TrackingCodeActionTypes = TrackingCodeActionTypes;
var FetchBasicTrackingCodeActionTypes = (0, _actions.createRequestTypes)(TrackingCodeActionTypes.FETCH_BASIC_TRACKING_CODE);
exports.FetchBasicTrackingCodeActionTypes = FetchBasicTrackingCodeActionTypes;
var FetchBasicTrackingCode = (0, _actions.createRequestActions)(FetchBasicTrackingCodeActionTypes);
exports.FetchBasicTrackingCode = FetchBasicTrackingCode;
var loadBasicTrackingCode = (0, _fluxActions.createAction)(TrackingCodeActionTypes.FETCH_BASIC_TRACKING_CODE);
exports.loadBasicTrackingCode = loadBasicTrackingCode;
var FetchAdvancedTrackingCodeActionTypes = (0, _actions.createRequestTypes)(TrackingCodeActionTypes.FETCH_ADVANCED_TRACKING_CODE);
exports.FetchAdvancedTrackingCodeActionTypes = FetchAdvancedTrackingCodeActionTypes;
var FetchAdvancedTrackingCode = (0, _actions.createRequestActions)(FetchAdvancedTrackingCodeActionTypes);
exports.FetchAdvancedTrackingCode = FetchAdvancedTrackingCode;
var loadAdvancedTrackingCode = (0, _fluxActions.createAction)(TrackingCodeActionTypes.FETCH_ADVANCED_TRACKING_CODE);
exports.loadAdvancedTrackingCode = loadAdvancedTrackingCode;
var SendTrackingCodeActionTypes = (0, _actions.createRequestTypes)(TrackingCodeActionTypes.SEND_TRACKING_CODE);
exports.SendTrackingCodeActionTypes = SendTrackingCodeActionTypes;
var SendTrackingCode = (0, _actions.createRequestActions)(SendTrackingCodeActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SendTrackingCodeActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('analyticsAndTracking.tracking.modal.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SendTrackingCodeActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('analyticsAndTracking.tracking.modal.error')));
  }
});
exports.SendTrackingCode = SendTrackingCode;
var sendTrackingCode = (0, _fluxActions.createAction)(TrackingCodeActionTypes.SEND_TRACKING_CODE, function (email) {
  return {
    data: email
  };
});
exports.sendTrackingCode = sendTrackingCode;